import { type ReactNode } from 'react';
import { Text } from '@mantine/core';
import { FooterSummaryCellContainer } from '@dealstack/frontend/shared/components/Table/MantineTable/Cells/cell.styles.ts';

interface Props {
	label: string;
	value: ReactNode;
	align?: 'flex-start' | 'center' | 'flex-end';
}

export const FooterSummaryCell = ({ label, value, align = 'flex-start' }: Props) => (
	<FooterSummaryCellContainer $align={align}>
		<Text size="xs" c="dark.0">
			{label}
		</Text>
		{typeof value === 'string' || typeof value === 'number' ? (
			<Text size="sm" fw={600}>
				{value}
			</Text>
		) : (
			value
		)}
	</FooterSummaryCellContainer>
);
